import { PremiumPaywallSignModes, PaywallAuthErrorCodes, SignInType } from "../../../../../../global/paywall/paywallInterfaces";


interface PremiumCalcalistPaywallMobileSigninEmailProps {
  emailOrPhone: string
  setEmailOrPhone: (emailOrPhone: string) => void
  setMode: (mode: PremiumPaywallSignModes) => void
  loginWithGoogle: () => void
  loginWithApple: () => void
  sendMail: () => void
  setAuthError?: (error: PaywallAuthErrorCodes) => void;
  setSignInType?: (type: SignInType) => void;
  signInType?: SignInType;
  authError: string

}


declare const window: Window & {
  ENABLE_SIGNIN_VIA_SMS: boolean;
}
const isSmsSignInEnabled = typeof window !== "undefined" && window.ENABLE_SIGNIN_VIA_SMS;


const errorMessage: Partial<Record<PaywallAuthErrorCodes, string>> = {
  [PaywallAuthErrorCodes.INVALID_EMAIL]: 'כתובת דוא"ל אינה תקינה',
  [PaywallAuthErrorCodes.INVALID_CELL_PHONE_NUMBER]: 'מספר טלפון אינו תקין',
  [PaywallAuthErrorCodes.FAILED_TO_SEND_OTP]: "אירעה שגיאה במערכת, אנא נסו שוב מאוחר יותר",
  [PaywallAuthErrorCodes.NOT_REGISTERED]: 'פרטי ההתחברות שהוזנו אינם נכונים',
  [PaywallAuthErrorCodes.NOT_REGISTERED_PHONE]: `פרטי ההתחברות שהוזנו אינם נכונים, ניתן לעדכן באזור האישי לאחר התחברות או לפנות ל<a  href="https://www.calcalist.co.il/subs/contact" target="_blank" className="contact-link">שירות הלקוחות</a>`,
  [PaywallAuthErrorCodes.OTP_MAX_ATTEMPTS]: "חרגת ממספר בקשות אימות. יש לפנות לשירות לקוחות",
  [PaywallAuthErrorCodes.NON_UNIQUE_PHONE_NUMBER]: `מספר הטלפון שייך ליותר מחשבון אחד. אנא הזדהה באמצעות כתובת דוא"ל`,
  [PaywallAuthErrorCodes.PHONE_NUMBER_NOT_NUMERIC]: `יש להקליד מספרים בלבד`
}


export const PremiumCalcalistPaywallMobileLoginEmail = (props: PremiumCalcalistPaywallMobileSigninEmailProps) => {

  const { emailOrPhone, setEmailOrPhone, loginWithApple, loginWithGoogle, setMode, sendMail, authError, setAuthError, signInType, setSignInType } = props

  const handleMailChange = (e) => {
    if (signInType === SignInType.otpPhone) {
      const phoneRegex = /^\d+$/;
      if (e.target.value && !phoneRegex.test(e.target.value)) {
        setAuthError(PaywallAuthErrorCodes.PHONE_NUMBER_NOT_NUMERIC);
        return;
      }
    }
    if (e.target.value.length === 0 && authError) {
      setAuthError(null);
    }
    setEmailOrPhone(e.target.value)
  }

  const handleSignInType = (method: SignInType) => {
    setSignInType(method);
    handleEmailReset();
  }

  const handleEmailReset = () => {
    setEmailOrPhone('');
    setAuthError(null);
  }

  const handleSendMail = () => {
    sendMail()
  }

  const handlePressKey = (e) => {
    if (e.key === 'Enter') {
      handleSendMail()
    }
  }

  return (
    <div className="premium-calcalist-paywall-mobile-signin-email">
      <div className="digital-edition-label">המהדורה הדיגיטלית</div>
      <h1 className="title">כניסה</h1>
      {isSmsSignInEnabled && <div className="signin-method-selector">
        <button
          className={`selector-btn ${signInType === SignInType.otpEmail ? "active" : ""}`}
          onClick={() => handleSignInType(SignInType.otpEmail)}
        >
          כניסה באמצעות מייל
        </button>
        <button
          className={`selector-btn ${signInType === SignInType.otpPhone ? "active" : ""}`}
          onClick={() => handleSignInType(SignInType.otpPhone)}
        >
          כניסה באמצעות נייד
        </button>
      </div>}
      <div className={`email-signin ${authError && authError === PaywallAuthErrorCodes.INVALID_EMAIL ? 'error' : ''}`}>
        <input onKeyDown={handlePressKey}
          value={emailOrPhone}
          onChange={handleMailChange}
          type="text"
          inputMode={signInType === SignInType.otpPhone ? "numeric" : "email"}
          {...(signInType === SignInType.otpPhone && {
            inputmode: "numeric",
            pattern: "[0-9]*"
          })}
          placeholder={signInType === SignInType.otpEmail ? "הקלידו כתובת מייל" : "הקלידו מספר נייד"}
        />
        {emailOrPhone && <div className="reset-icon" onClick={handleEmailReset}></div>}
        {authError && <p className="error-text" dangerouslySetInnerHTML={{ __html: errorMessage[authError] }}></p>}
      </div>
      <div className="buttons-container">
        <button className="button-base continue" onClick={handleSendMail}>המשך</button>
      </div>
      <div className="separator">
        <span className="text">או התחברו באמצעות</span>
      </div>
      <div className="social-signin">
        <button className="social-button google-btn" onClick={loginWithGoogle}><span>גוגל</span></button>
        <button className="social-button apple-btn" onClick={loginWithApple}><span>אפל</span></button>
      </div>
      <div className="signup">
        <div>אין לך חשבון?<a href="#" onClick={() => setMode("signUp")}>הרשמה</a></div>
      </div>
      <div className="newspapper-users" >
        <div><span>מנויים לעיתון</span> <span className="calcalist-label"></span>?</div>
        <div className="more-details">הזינו את המייל שלכם בשדה למעלה, וכנסו למהדורה הדיגיטלית</div>
      </div>
    </div>
  )
}
